import { render, staticRenderFns } from "./MineTabs.vue?vue&type=template&id=78ac0a86&scoped=true"
import script from "./MineTabs.vue?vue&type=script&lang=js"
export * from "./MineTabs.vue?vue&type=script&lang=js"
import style0 from "./MineTabs.vue?vue&type=style&index=0&id=78ac0a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac0a86",
  null
  
)

export default component.exports